module.exports = __webpack_public_path__ + "static/media/starter-credit-coin-icon.3154484b.svg";